// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

export const fetchRcns = (query = '') => fetchWrapper(`/rcns${query}`)

export const fetchRcnStatuses = () => fetchWrapper('/rcn-statuses')
